"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Contract = void 0;
var accounts_1 = require("@near-js/accounts");
Object.defineProperty(exports, "Contract", { enumerable: true, get: function () { return accounts_1.Contract; } });
